module.exports = __webpack_public_path__ + "img/blank_profile_big.d492f7d4.svg";